import script from "./RemittanceRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./RemittanceRecord.vue?vue&type=script&setup=true&lang=js"

import "./RemittanceRecord.vue?vue&type=style&index=0&id=160940ca&lang=css"

const __exports__ = script;

export default __exports__